import { CounterpartyType, type BookingBalanceDto } from '@carvia/ros-client-types';
import { toRef, type MaybeRefOrGetter } from '@vueuse/core';
import { computed } from 'vue';
import { EPSILON } from '@/constants';

export const useOpenBalance = (
  currentBalanceRef: MaybeRefOrGetter<BookingBalanceDto | undefined>,
) => {
  const currentBalance = toRef(currentBalanceRef);
  return computed(() => ({
    hasOpenBalance: !currentBalance.value
      ? false
      : currentBalance.value[CounterpartyType.CUSTOMER] > EPSILON ||
        currentBalance.value[CounterpartyType.AGENCY] > EPSILON ||
        currentBalance.value[CounterpartyType.OTHER] > EPSILON,
    hasOpenRefunds: !currentBalance.value
      ? false
      : currentBalance.value[CounterpartyType.CUSTOMER] < -EPSILON ||
        currentBalance.value[CounterpartyType.AGENCY] < -EPSILON ||
        currentBalance.value[CounterpartyType.OTHER] < -EPSILON,
  }));
};
